import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

// Styles
const styles = StyleSheet.create({
  // page: {
  //   padding: 20,
  //   fontSize: 10,
  //   paddingTop: 80,
  // },
  page: {
    paddingTop: 90,
    paddingBottom: 110,   // ← increase from 90 to 110
    paddingHorizontal: 30,
    fontSize: 9,
},
  section: {
    marginBottom: 10,
      // marginTop: 80,
  },
  headerContainer: {
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: 20,
    marginBottom: 20
  },
  headerText: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 10
  },
  subHeaderText: {
    fontSize: 10,
    fontWeight: "bold",
    //textAlign: "center",
    marginBottom: 5
  },
  table: {
    display: "table",
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    // marginTop: 60
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
    height: 35,
  },
  tableRowLast: {
    flexDirection: "row",
  },
  //   tableColHeader1: {
  //     width: "30px",
  //     borderRightWidth: 1,
  //     borderRightColor: "#000",
  //     padding: 5,
  //     fontWeight: "bold",
  //     backgroundColor: "#EEE",
  //     justifyContent: "center",
  //     alignItems: "center",
  //     textAlign: "center",
  //   },
  //   tableCol1: {
  //     width: "30px",
  //     borderRightWidth: 1,
  //     borderRightColor: "#000",
  //     padding: 5,
  //     justifyContent: "center",
  //     alignItems: "center",
  //     textAlign: "right",
  //   },
  //   tableColHeader: {
  //     width: "100px",
  //     flex: 1,
  //     borderRightWidth: 1,
  //     borderRightColor: "#000",
  //     padding: 5,
  //     fontWeight: "bold",
  //     backgroundColor: "#EEE",
  //     justifyContent: "center",
  //     alignItems: "center",
  //     textAlign: "center",
  //   },
  //   tableColHeaderDescription: {
  //     width: "500px",
  //     flex: 2.5,
  //     borderRightWidth: 1,
  //     borderRightColor: "#000",
  //     padding: 5,
  //     fontWeight: "bold",
  //     backgroundColor: "#EEE",
  //     justifyContent: "center",
  //     alignItems: "center",
  //     textAlign: "center",
  //   },

  //   tableCol: {
  //     width: "100px",
  //     flex: 1,
  //     borderRightWidth: 1,
  //     borderRightColor: "#000",
  //     padding: 5,
  //     justifyContent: "center",
  //     alignItems: "center",
  //     textAlign: "left",
  //   },

  //  tableColDescription: {
  //   width: "500px",
  //   flex: 2.5,
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   textAlign: "left",       
  //   alignItems: "flex-start",  
  //   justifyContent: "center",  
  // },

  // tableColHeader1: {
  //   width: "30px", // keep S.No column narrow
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   fontWeight: "bold",
  //   backgroundColor: "#EEE",
  //   textAlign: "center",
  // },
  // tableCol1: {
  //   width: "30px", // keep it narrow
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   textAlign: "right",
  // },
  // tableColHeader: {
  //   flex: 1, // Allow responsive layout
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   fontWeight: "bold",
  //   backgroundColor: "#EEE",
  //   textAlign: "center",
  // },
  // tableColHeaderDescription: {
  //   flex: 2.5, // Give more space to Description
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   fontWeight: "bold",
  //   backgroundColor: "#EEE",
  //   textAlign: "center",
  // },
  // tableCol: {
  //   flex: 1, // Responsive width for general cells
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   textAlign: "left",
  // },
  // tableColDescription: {
  //   flex: 2.5, // Give more space to Description
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   textAlign: "left",
  // },
  tableColHeader1: {
    width: 30,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  tableCol1: {
    width: 30,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "right",
  },
  tableColHeader: {
    width: 70,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
    tableColApprDateHeader: {
    width: 70,
    // borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  tableColHeaderProject: {
    width: 50,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  tableColHeaderSmall: {
    width: 70,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  tableColHeaderDescription: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  tableCol: {
    width: 70,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  tableColApprDate: {
    width: 70,
    // borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  tableColProject: {
    width: 50,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },

  tableColSmall: {
    width: 70,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  // tableColDescription: {
  //   flex: 1,
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   textAlign: "left",
  // },
  tableColDescription: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
    flexWrap: "wrap",      // <-- enables wrapping
    maxWidth: "100%"       // <-- required for proper wrap
  },
/*Header*/
  headerWrapper: {
    position: "absolute",
    top: 15,
    left: 20,
    right: 20,
    height: 50,
    justifyContent: "center",
    alignItems: "center",
  },
  headerImage: {
    width: "100%",
    height: 50,
    objectFit: "contain",
  },
  
  /* FOOTER */

footerWrapper: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 100,          // ← increase from 80 to 100
    paddingHorizontal: 30,
    justifyContent: "center",
    alignItems: "center",
},

footerImage: {
    width: "100%",
    height: 95,           // ← increase from 75 to 95
    objectFit: "contain",
},

});

// Split data: 20 on first page, 26 afterwards
// const paginateData = (data) => {
//   const firstPage = data.slice(0, 13);
//   const otherPages = [];

//   for (let i = 13; i < data.length; i += 17) {
//     otherPages.push(data.slice(i, i + 17));
//   }

//   return [firstPage, ...otherPages];
// };
// const paginateData = (data, rowsPerPage = 10) => {
//   const pages = [];

//   for (let i = 0; i < data.length; i += rowsPerPage) {
//     pages.push(data.slice(i, i + rowsPerPage));
//   }

//   return pages;
// };

const FIRST_PAGE_COUNT = 8;
const OTHER_PAGE_COUNT = 10;

const paginateData = (data) => {
  const pages = [];

  // First page
  pages.push(data.slice(0, FIRST_PAGE_COUNT));

  // Remaining pages
  for (
    let i = FIRST_PAGE_COUNT;
    i < data.length;
    i += OTHER_PAGE_COUNT
  ) {
    pages.push(data.slice(i, i + OTHER_PAGE_COUNT));
  }

  return pages;
};


//const TimeSheetPDF = ({ data = [], filters = {} }) => {
const TimeSheetPDF = ({ data = [], filters = {}, projectName = "", managerName = "" }) => {
  const pages = paginateData(data);
  pages.forEach((page, i) => {
    console.log(`Page ${i + 1} first row index:`, data.indexOf(page[0]));
  });
  const formatDate = (inputDate) => {
    if (!inputDate) return "";
    const [year, month, day] = inputDate.split("-");
    return `${day}-${month}-${year}`;
  };

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  return (
    <Document>

      {pages.map((pageData, pageIndex) => (
        <Page size="A4" orientation="landscape" style={styles.page} key={pageIndex}>
 <View fixed style={styles.headerWrapper}>
            {filters.HeaderImg && (
              <Image
                src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
                style={styles.headerImage}
              />
            )}
          </View>
          {pageIndex === 0 && (

            <View style={styles.section}>
              <Text style={styles.headerText}>
                {`Timesheet - ${filters.EmployeeID} (${monthNames[filters.Month - 1]} - ${filters.Year})`}
              </Text>


              <Text style={styles.subHeaderText}>
                {`Project: ${projectName}`}
              </Text>
              {/* <Text style={styles.subHeaderText}>
             {`Manager: ${managerName}`}
           </Text> */}
              {managerName !== "" && (
                <Text style={styles.subHeaderText}>
                  {`Manager: ${managerName}`}
                </Text>
              )}
              <Text style={styles.subHeaderText}>
                {"Comp -> Completed ||Appr -> Approved"}
              </Text>
            </View>

          )}
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text style={styles.tableColHeader1}>SL#</Text>
              <Text style={styles.tableColHeader}>Date</Text>
              <Text style={styles.tableColHeaderProject}>Project</Text>
              <Text style={styles.tableColHeaderDescription}>Task</Text>
              <Text style={styles.tableColHeader1}>Hrs</Text>
              <Text style={styles.tableColHeader}>Comp Date</Text>
              <Text style={styles.tableColHeaderSmall}>Appr By</Text>
              <Text style={styles.tableColApprDateHeader}>Appr Date</Text>
            </View>

            {pageData.map((row, rowIndex) => {
               const globalIndex =
  pageIndex === 0
    ? rowIndex + 1
    : FIRST_PAGE_COUNT +
      (pageIndex - 1) * OTHER_PAGE_COUNT +
      rowIndex +
      1;

              const isLast = rowIndex === pageData.length - 1;
              return (
                <View
                  key={rowIndex}
                  style={isLast ? styles.tableRowLast : styles.tableRow}
                >
                  {/* <Text style={styles.tableCol1}>{rowIndex + 1}</Text> */}
                  <Text style={styles.tableCol1}>{globalIndex}</Text>
                  <Text style={styles.tableCol}>{row.DaliytaskCorrectDate}</Text>
                  <Text style={styles.tableColProject}>{row.ProjectCode}</Text>
                  {/* <Text style={styles.tableColDescription}>{row.Description || row.Comments}</Text> */}
                  <Text style={styles.tableColDescription}>
                    {[row.Description?.trim(), row.Comments?.trim()]
                      .filter(Boolean)
                      .join(" || ")}
                  </Text>

                  <Text style={styles.tableCol1}>{row.ActualHourse}</Text>
                  <Text style={styles.tableCol}>{row.DaliytaskCorrectDate?.split(" ")[0]}</Text>
                  <Text style={styles.tableColSmall}>{row.ManagerCode}</Text>
                  <Text style={styles.tableColApprDate}>{row.ApprovedDate}</Text>
                </View>
              );
            })}
          </View>
          <View
            fixed
            style={{
              position: "absolute",
              bottom: 103,
              left: 0,
              right: 0,
              textAlign: "center",
              fontSize: 10,
               color: "#555",
            }}

          >
            <Text>Page {pageIndex + 1} of {pages.length}</Text>
          </View>
  <View fixed style={styles.footerWrapper}>
            {filters.FooterImg && (
              <Image
                src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
                style={styles.footerImage}
              />
            )}
          </View>

        </Page>
      ))}
    </Document>
  );
};

export default TimeSheetPDF;
